import { Module } from 'vuex'
import { StaticDataState, CommonAppState } from '@bd/store-modules/types'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

const staticData: Module<StaticDataState, CommonAppState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default staticData
